import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import EffectChooser from "components/effects/EffectChooser.js";

const FormantEffect = ({formant, track}) => { 
    let [effect, setEffect] = useState(formant.effect);

    useEffect(() => {
        if (formant) {
            setEffect(formant.effect);
        }
    }, [formant]);

    const onChange = useCallback((effect) => {
        formant.useEffect(effect);
        setEffect(effect);
    }, [setEffect, formant]);

    const onDelete = useCallback(() => {
        setEffect(undefined);
        formant.bypassEffect();
    }, [effect, setEffect, formant]);

    return (
        <div className="formant-effect">
          <div className="sub-header">Formant {formant.number + 1} FX</div>
          <EffectChooser
            track={track}
            sequencerEngine={track.sequencerEngine}
            onDelete={onDelete}
            effect={effect}
            onChange={onChange}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormantEffect);
